import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React, { useState, useEffect } from 'react';
import { Modal } from '@dfds-ui/modal/modal';
import Login from '../Login';
import { css } from '@emotion/core';
export var LoginModalContext = React.createContext(undefined);
export function useLoginModal() {
  var context = React.useContext(LoginModalContext);
  return {
    insideModal: !!context,
    setHeading: context ? context.setHeading : function () {
      return undefined;
    }
  };
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "l57rop",
  styles: "padding-bottom:10px;"
} : {
  name: "l57rop",
  styles: "padding-bottom:10px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var LoginModal = function LoginModal(_ref2) {
  var _ref2$modalOpen = _ref2.modalOpen,
      modalOpen = _ref2$modalOpen === void 0 ? false : _ref2$modalOpen,
      _ref2$preventClosing = _ref2.preventClosing,
      preventClosing = _ref2$preventClosing === void 0 ? false : _ref2$preventClosing,
      _onLogin = _ref2.onLogin,
      _onPasswordReset = _ref2.onPasswordReset,
      _onRegisterLogin = _ref2.onRegisterLogin,
      onModalClose = _ref2.onModalClose,
      rest = _objectWithoutProperties(_ref2, ["modalOpen", "preventClosing", "onLogin", "onPasswordReset", "onRegisterLogin", "onModalClose"]);

  var _useState = useState(modalOpen),
      _useState2 = _slicedToArray(_useState, 2),
      modalShown = _useState2[0],
      setModalShown = _useState2[1];

  var _useState3 = useState(function () {
    return undefined;
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      heading = _useState4[0],
      setHeading = _useState4[1];

  useEffect(function () {
    setModalShown(modalOpen);
  }, [modalOpen]);
  var modalClosingParams = preventClosing ? {
    shouldCloseOnOverlayClick: false,
    shouldCloseOnEsc: false,
    showClose: false
  } : {};
  return ___EmotionJSX(LoginModalContext.Provider, {
    value: {
      setHeading: setHeading
    }
  }, ___EmotionJSX(Modal, _extends({
    isOpen: modalShown
  }, modalClosingParams, {
    noContentPadding: true,
    onRequestClose: function onRequestClose() {
      setModalShown(false);

      if (onModalClose) {
        onModalClose();
      }
    },
    heading: heading
  }, rest), ___EmotionJSX(Login, {
    css: _ref,
    onLogin: function onLogin() {
      setModalShown(!modalShown);

      if (_onLogin) {
        _onLogin();
      }
    },
    onPasswordReset: function onPasswordReset() {
      setModalShown(!modalShown);

      if (_onPasswordReset) {
        _onPasswordReset();
      }
    },
    onRegisterLogin: function onRegisterLogin() {
      setModalShown(!modalShown);

      if (_onRegisterLogin) {
        _onRegisterLogin();
      }
    }
  })));
};

export default LoginModal;